import React from 'react'
import { VStack, StylesProvider, useMultiStyleConfig } from '@chakra-ui/react'

import { useFieldList, FieldListProvider } from './useFieldList'

export const FieldList = React.forwardRef(({ isLoading, isReadOnly, ...props }, ref) => {
  const styles = useMultiStyleConfig('FieldList', props)
  const context = useFieldList({ isLoading, isReadOnly })

  return (
    <StylesProvider value={styles}>
      <FieldListProvider value={context}>
        <VStack {...props} sx={styles.FieldList} align='stretch' spacing={2} />
      </FieldListProvider>
    </StylesProvider>
  )
})

export default FieldList
